module.exports = __webpack_public_path__ + "static/media/threedots.874cd32b.svg";